export default "__VITE_ASSET__feaf1f74__"